import React, { Component } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

class MentionListsRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: this.props.List
    };

    this.goToEdit = this.goToEdit.bind(this);
  }

  goToEdit() {
    const params = this.props.Params;

    params["session_operation"] = this.state.list.type;
    params["session_date"] = moment(this.state.list.date).toDate();

    this.props.history.push({
      pathname: `/search/${this.state.list.type}/${moment(
        this.state.list.date
      ).format("YYYY-MM-DD")}`,
      state: { params: this.state }
    });
  }

  render() {
    const list = this.state.list;

    const submitted =
      moment(list.submitted) > moment("1990-01-01") ? list.submitted : null;

    const update =
      moment(list.update) > moment("1990-01-01") ? list.update : null;

    return (
      <React.Fragment>
        <tr className="spacer"></tr>
        <tr className={this.props.Row}>
          <td>{moment(list.date).format("DD. MMMM YYYY")}</td>
          <td></td>
          <td>{list.persons.length}</td>
          <td>
            {submitted
              ? `Sendt: ${moment(submitted).format("HH:mm D.MMM YYYY")}`
              : "Under arbeid"}
          </td>
          <td>{update ? `${moment(update).format("HH:mm D.MMM")}` : "-"}</td>
          <td>
            <button
              onClick={this.goToEdit}
              className={classNames("button", "small", {
                yellow: !submitted
              })}
            >
              Gå til liste
            </button>
          </td>
          <td></td>
        </tr>
      </React.Fragment>
    );
  }
}

export default withRouter(MentionListsRow);
